export default "__VITE_PUBLIC_ASSET__7dbc060c__"